import { computed, reactive } from 'vue'
import { camelizeKeys } from 'humps'
import { useLoader } from './useLoader'
import { useError } from './useError'
import { usePoliticalActions } from '@/services/politicalAction/usePoliticalActions'
import { useBudgets } from '@/services/useBudgets'
import axios from '@/axios'

const topState = reactive({
  activitiesTop: [],
  receiptsTop: [],
  notificationTop: [],
})

export const useTopData = () => {
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const { getUsers } = usePoliticalActions()
  const getActivitiesTop = async () => {
    try {
      toggleShowLoader(true)
      let res = await axios.get('/actions/top')
      res = camelizeKeys(res)
      topState.activitiesTop = Array.from(res.data.documents)
      getUsers()
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      console.log(e)
      toggleShowLoader(false)
    }
  }

  const getNotificationTop = async () => {
    try {
      toggleShowLoader(true)
      let res = await axios.get('/notifications/top')
      res = camelizeKeys(res)
      topState.notificationTop = Array.from(res.data.notifications)
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  const getReceiptsTop = async () => {
    try {
      toggleShowLoader(true)
      let res = await axios.get('/receipts/top')
      res = camelizeKeys(res)
      topState.receiptsTop = Array.from(res.data.receipts)
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  /**
   * レスポンスが正常な場合総括資料を取得する
   *
   * @param {object} response
   * @returns void
   */
  const getTopDataAfterResponse = async response => {
    if (response?.data?.code !== 0) {
      return
    }
    const { getRemainingBudget } = useBudgets()
    await getRemainingBudget()
    await getNotificationTop()
    await getActivitiesTop()
    await getUsers()
    await getReceiptsTop()
  }

  return {
    activitiesTop: computed(() => topState.activitiesTop),
    getActivitiesTop,
    notificationTop: computed(() => topState.notificationTop),
    getNotificationTop,
    receiptsTop: computed(() => topState.receiptsTop),
    getReceiptsTop,
    getTopDataAfterResponse,
  }
}
